import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaAngleLeft } from "react-icons/fa";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "../../../components/common/css/campaignview.scss";
import "../../new/new.scss";

const Viewinvestment = () => {
  const navigate = useNavigate();
  const id = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");

  const fetchjobData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-myinvestment-details-by-id",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.investmentId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data.data.rows[0]);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchjobData();
  }, []);

  const handleExportExcel = async () => {
    const token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "reports/transaction",

      data: {
        investmentId: data?.id,
      },
    };

    axios(config)
      .then(function async(response) {
        if (response) {
          setLoading(false);
          var abc = base64ToBlob(response.data, "application/vnd.ms-excel");
          const url = window.URL.createObjectURL(abc);
          const link = document.createElement("a");
          link.href = url;
          const filename = getDateFormat(new Date()) + "_" + data?.id;
          link.setAttribute("download", `${filename}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const exportCorporate = () => {
    const data1 = Array.isArray(data) ? data : [data];
    const dataToExport = data1.map((campaign) => ({
      ID: campaign?.campaign_detail?.id,
      "Campaign Name": campaign?.campaign_detail?.corporation_legal_name,
      "Official Email": campaign?.campaign_detail?.camp_email,
      "Company Address": campaign?.campaign_detail?.registered_address,
      City: campaign?.campaign_detail?.city,
      EnityType: campaign?.campaign_detail?.entitytype,
      "Buisness No": campaign?.campaign_detail?.business,
      "Craax Account": campaign?.campaign_detail?.craax_account,
      "Date Of Incorp": campaign?.campaign_detail?.date_of_incorp,
      "How many years in business":
        campaign?.campaign_detail?.how_many_yearsin_business,
      "Corporation Name": campaign?.user?.comp__name,
      "Investment Account": campaign?.investmentAccount,
      Amount: campaign?.amount,
      Currency: campaign?.currency,
      CustomerId: campaign?.user_id,
      OrderId: campaign?.order_id,
      "Bank Name":campaign?.user?.user_banking_details?.corporate_bank_name,
      "Institutional Number":campaign?.user?.user_banking_details?.corporate_institution_number,
      "Transit Number":campaign?.user?.user_banking_details?.corporate_transit_number,
      "Account Number":campaign?.user?.user_banking_details?.corporate_account_number,
      
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Campaigns");
    XLSX.writeFile(workbook, "CampaignListing.xlsx");
  };
  
  const exportIndividual = () => {
    const data1 = Array.isArray(data) ? data : [data];
    const dataToExport = data1.map((campaign) => ({
      ID: campaign?.campaign_detail?.id,
      "Campaign Name": campaign?.campaign_detail?.corporation_legal_name,
      "Official Email": campaign?.campaign_detail?.camp_email,
      "Company Address": campaign?.campaign_detail?.registered_address,
      "City": campaign?.campaign_detail?.city,
      EnityType: campaign?.campaign_detail?.entitytype,
      "Buisness No": campaign?.campaign_detail?.business,
      "Craax Account": campaign?.campaign_detail?.craax_account,
      "Date Of Incorp": campaign?.campaign_detail?.date_of_incorp,
      "How many years in business":
      campaign?.campaign_detail?.how_many_yearsin_business,
      "Investment Account": campaign?.investmentAccount,
      "Firstname": campaign?.user?.firstname,
      "Lastname": campaign?.user?.lastname,
      "Amount": campaign?.amount,
      "Currency": campaign?.currency,
      "CustomerId": campaign?.user_id,
      "OrderId": campaign?.order_id,
      "Bank Name":campaign?.user?.user_banking_details?.bank_name,
      "Institutional Number":campaign?.user?.user_banking_details?.institution_number,
      "Transit Number":campaign?.user?.user_banking_details?.transit_number,
      "Account Number":campaign?.user?.user_banking_details?.account_number,
      "Account Holder Name":campaign?.user?.user_banking_details?.account_holder,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Campaigns");
    XLSX.writeFile(workbook, "CampaignListing.xlsx");
  };

  const updateInvestment = async (newStatus) => {
    try {
      const token = localStorage.getItem("accessToken");
      await axios.put(
        process.env.REACT_APP_API + "admin/update-investment",
        { id: data?.id, paymentStatus: newStatus },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
        }
      );
      fetchjobData()
      Swal.fire({
        title: "Payment status updated successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        title: "Error updating payment status",
        text: error.response?.data?.message || "Something went wrong",
        icon: "error",
      });
    }
  };

  const getDateFormat = (date) => {
    const today = date;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return yyyy + "" + mm + "" + dd;
  };

  const base64ToBlob = (base64Data, contentType) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Investment</h1>
        </div>
        <div className="single">
          <div className="singleContainer">
            <div className="top">
              <div
                className="left"
                style={{ textAlign: "left", boxShadow: "unset" }}
              >
                <div className="topHeading">
                  {" "}
                  <h1
                    className="title"
                    style={{ fontSize: "16px", color: "#333", width: "100%" }}
                  >
                    Corporate Information
                  </h1>
                  <div className="exportBtn-divSec">
                    <button
                      className="custBtn"
                      id="downloadbtn"
                      onClick={data?.investmentAccount == "INDIVIDUAL" ? exportIndividual : exportCorporate}
                    >
                      Export as Excel
                    </button>
                  </div>
                </div>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Company Name:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.corporation_legal_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Email</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.camp_email}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Address:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.registered_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Head Office Address</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.city}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.country_id}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.province}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Type Of Enitity:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.entitytype}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Buisness No:</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.business}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Fax</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.fax !== "undefined" &&
                        data?.campaign_detail?.fax !== "null"
                          ? data?.campaign_detail?.fax
                          : "-"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Craax Acoount</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.craax_account !== "undefined" &&
                        data?.campaign_detail?.craax_account !== "null"
                          ? data?.campaign_detail?.craax_account
                          : "-"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Date Of Corp</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.date_of_incorp}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Year Of Corporation</span>
                      <span className="itemValue">
                        {data?.campaign_detail?.how_many_yearsin_business}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="single">
          <div className="singleContainer">
            <div className="top">
              <div
                className="left"
                style={{ textAlign: "left", boxShadow: "unset" }}
              >
                <div className="topHeading">
                  {" "}
                  <h1
                    className="title"
                    style={{ fontSize: "16px", color: "#333", width: "100%" }}
                  >
                    Personal Information
                  </h1>
                </div>

                {data?.investmentAccount === "INDIVIDUAL" ? (
                  <div className="item">
                    <div className="details profile-info">
                      <div className="detailItem">
                        <span className="itemKey">First Name</span>
                        <span className="itemValue">
                          {data?.user?.firstname}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Last Name</span>
                        <span className="itemValue">
                          {data?.user?.lastname}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Investment Account</span>
                        <span className="itemValue">
                          {data?.investmentAccount}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign ID</span>
                        <span className="itemValue">{data?.campaign_id}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.campaign_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Corporate Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.corporation_legal_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Amount</span>
                        <span className="itemValue">{data?.amount}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Currency</span>
                        <span className="itemValue">{data?.currency}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Bank Name</span>
                        <span className="itemValue">{data?.user?.user_banking_details?.bank_name}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Institutional Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.institution_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Transaction Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.transit_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Number</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.account_number}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Holder</span>
                        <span className="itemValue">
                          {data?.user?.user_banking_details?.account_holder}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Order Number</span>
                        <span className="itemValue">{data?.order_id}</span>
                      </div>
                      
                      <div className="detailItem">
                        <span className="itemKey">Payment Method</span>
                        <span className="itemValue">{data?.paymentOption}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Payment Status</span>
                        <span className="itemValue">{data?.paymentStatus}</span>
                        {/* <select
                          className="itemValue dropdown"
                          value={paymentStatus}
                          onChange={(e) => {
                            setPaymentStatus(e.target.value);
                            updateInvestment(e.target.value);
                          }}
                          style={{ width: "200px" }}
                        >
                          <option value="PAID">PAID</option>
                          <option value="UNPAID">UNPAID</option>
                        </select> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="item">
                    <div className="details profile-info">
                      <div className="detailItem">
                        <span className="itemKey">Corporation Name</span>
                        <span className="itemValue">
                          {data?.user?.comp__name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Investment Account</span>
                        <span className="itemValue">
                          {data?.investmentAccount}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign ID</span>
                        <span className="itemValue">{data?.campaign_id}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign Name</span>
                        <span className="itemValue">
                          {data?.campaign_detail?.corporation_legal_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Amount</span>
                        <span className="itemValue">{data?.amount}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Currency</span>
                        <span className="itemValue">{data?.currency}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Bank Name</span>
                        <span className="itemValue">{data?.user?.user_banking_details?.corporate_bank_name}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Institutional Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_institution_number
                          }
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Transaction Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_transit_number
                          }
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Account Number</span>
                        <span className="itemValue">
                          {
                            data?.user?.user_banking_details
                              ?.corporate_account_number
                          }
                        </span>
                      </div>
                      
                      <div className="detailItem">
                        <span className="itemKey">Order Number</span>
                        <span className="itemValue">{data?.order_id}</span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Payment Method</span>
                        <span className="itemValue">{data?.paymentOption}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Payment Action</span>
                        <span className="itemValue">{data?.paymentStatus}</span>
                        {/* <select
                          className="itemValue dropdown"
                          value={paymentStatus}
                          onChange={(e) => {
                            setPaymentStatus(e.target.value);
                            updateInvestment(e.target.value);
                          }}
                          style={{ width: "200px" }}
                        >
                          <option value="PAID">PAID</option>
                          <option value="UNPAID">UNPAID</option>
                        </select> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewinvestment;
